import { Props, Select, SingleValue } from 'chakra-react-select';

import { noop } from '@blockpulse3/data/shared';
import { HoldingMethod } from '@blockpulse3/graphql/hooks';

import { MenuList } from './components';
import { HoldingMethodOption, HoldingMethodOptionGroup } from './types';

export type HoldingMethodSelectProps = Props<
  HoldingMethodOption,
  false,
  HoldingMethodOptionGroup
> & {
  /* ** Callback when selecting holding method ** */
  onChange?: (option: SingleValue<HoldingMethodOption>) => void;
  /* ** Callback on add fiscal account ** */
  onAddFiscalAccount?: () => void;
  /* ** Fundraising allowed holding methods ** */
  allowedHoldingMethods: HoldingMethod[] | null | undefined;
};

export function HoldingMethodSelect({
  defaultValue,
  onChange = noop,
  onAddFiscalAccount = noop,
  allowedHoldingMethods,
  ...props
}: HoldingMethodSelectProps): JSX.Element {
  const handleChange = (option: SingleValue<HoldingMethodOption>): void => {
    onChange(option);
  };

  const handleClick = (): void => {
    onAddFiscalAccount();
  };

  return (
    <Select<HoldingMethodOption, false>
      colorScheme="gray"
      defaultValue={defaultValue}
      getOptionValue={(option): string => option.value || option.type}
      isSearchable={false}
      menuPosition="fixed"
      selectedOptionStyle="check"
      chakraStyles={{
        option: (provided, state) => ({
          ...provided,
          background: state.isSelected && 'gray.50',
          fontWeight: state.isSelected && '500',
          fontSize: 'sm',
        }),
        singleValue: (provided) => ({
          ...provided,
          fontWeight: 650,
          fontSize: 'sm',
        }),
      }}
      components={{
        MenuList: (props) => (
          <MenuList
            allowedHoldingMethods={allowedHoldingMethods}
            onClick={handleClick}
            {...props}
          />
        ),
      }}
      onChange={handleChange}
      {...props}
    />
  );
}
